/**
 * Typed constants for feature flag names
 */
export const FeatureFlag = {
  POSTS: 'posts',
  USER_MESSAGES: 'user_messages',
  REPORT_USER_CONTENT: 'report_user_content',
  SOCIAL: 'social',
} as const

/**
 * Type-safe feature flag names — derived from the constant so it stays in sync
 */
export type FeatureFlagName = (typeof FeatureFlag)[keyof typeof FeatureFlag]

/**
 * Helper to check if a string is a valid feature flag
 */
export const isValidFeatureFlag = (flag: string): flag is FeatureFlagName => {
  return (Object.values(FeatureFlag) as string[]).includes(flag)
}
